export const LOADER_SIZE = {
  large: 20,
  medium: 16,
  small: 14,
};

export const COLOR_WHITE_LIST = ['primary', 'secondary', 'info', 'error'];
